import { mapActions } from 'pinia'
import useWebStore from '../stores/web'
import type { App } from 'vue'
import type { FormInput } from '@modules/Core/types/FormBuilder'
import deepcopy from 'ts-deepcopy'

const methods = {
    ...mapActions(useWebStore, ['get', 'put', 'post', 'postFile', 'delete']),
    prepareDataToSend(data: any, inputs: FormInput[], originalData: any) {
        if (!data || !inputs || !originalData) return {}
        const originalDataClone = deepcopy(originalData)
        const dataClone = deepcopy(data)
        let updatedItem: any = {}
        let getitems = function (
            inputs: FormInput[],
            itemActual: any,
            originalItem: any
        ) {
            inputs.forEach((input) => {
                if ('ignore' in input && input.ignore) return
                let inputs = 'inputs' in input ? input.inputs : null,
                    subItem = 'subItem' in input ? input.subItem : null
                if ('type' in input)
                    if (input.type == 'code') {
                        inputs = [
                            {
                                type: 'select',
                                name: 'type_code',
                            },
                            {
                                type: 'text',
                                name: 'code',
                            },
                            {
                                type: 'text',
                                name: 'secondary_code',
                            },
                        ] as FormInput[]
                    } else if (input.type == 'address') {
                        inputs = [
                            {
                                type: 'select',
                                name: 'country',
                            },
                            {
                                type: 'text',
                                name: 'postalcode',
                            },
                            {
                                type: 'text',
                                name: 'state',
                            },
                            {
                                type: 'text',
                                name: 'city',
                            },
                            {
                                type: 'text',
                                name: 'district',
                            },
                            {
                                type: 'text',
                                name: 'street',
                            },
                            {
                                type: 'number',
                                name: 'number',
                            },
                            {
                                type: 'text',
                                name: 'complement',
                            },
                        ] as FormInput[]
                    }

                if (inputs) {
                    if (subItem) {
                        getitems(
                            inputs,
                            itemActual[subItem] ?? {},
                            originalItem[subItem] ?? {}
                        )
                    } else {
                        getitems(inputs, itemActual, originalItem)
                    }
                } else if ('name' in input) {
                    const sendName =
                        'onSendName' in input && input.onSendName
                            ? input.onSendName
                            : input.name
                    const type =
                        'type' in input && typeof input.type === 'function'
                            ? input.type(data)
                            : 'type' in input
                              ? input.type
                              : 'text'

                    if (Array.isArray(itemActual[input.name])) {
                        const originalVal = [
                            ...(originalItem[input.name] ?? []),
                        ] as any[]
                        switch (type) {
                            case 'custom-fields':
                            case 'customFields':
                            default:
                                updatedItem[sendName] = itemActual[input.name]
                                break
                            case 'model-select':
                                if (
                                    'select' in input &&
                                    input.select &&
                                    input.multiple
                                ) {
                                    const select = input.select
                                    if (originalItem[input.name])
                                        originalItem[input.name] = originalItem[
                                            input.name
                                        ].map((i: any) => i[select])
                                    if (itemActual[input.name])
                                        itemActual[input.name] = itemActual[
                                            input.name
                                        ].map((i: any) => i[select])
                                }
                                const sortedItemActual =
                                    itemActual[input.name].sort()
                                if (
                                    originalVal.length !=
                                        itemActual[input.name].length ||
                                    (!!input.input?.select &&
                                        originalVal
                                            .map((i) => i[input.input.select])
                                            .sort()
                                            .some(
                                                (i, idx) =>
                                                    i != sortedItemActual[idx]
                                            ))
                                ) {
                                    updatedItem[sendName] =
                                        'filter' in input && input.filter
                                            ? input.filter(sortedItemActual)
                                            : sortedItemActual
                                }
                                break
                        }
                    } else {
                        if (
                            type == 'model-select' &&
                            'select' in input &&
                            input.select
                        ) {
                            if (originalItem[input.name])
                                originalItem[input.name] =
                                    originalItem[input.name][input.select]
                            if (itemActual[input.name])
                                itemActual[input.name] =
                                    itemActual[input.name][input.select]
                        }
                        if (
                            originalItem[input.name] !==
                                itemActual[input.name] &&
                            !(
                                'preventSendOnEmpty' in input &&
                                input.preventSendOnEmpty &&
                                String(itemActual[input.name]).length == 0
                            )
                        ) {
                            if (type == 'none') {
                                updatedItem[input.name] = null
                            } else
                                updatedItem[sendName] =
                                    'filter' in input && input.filter
                                        ? input.filter(itemActual[input.name])
                                        : itemActual[input.name]
                        }
                    }
                }
            })
        }
        getitems(inputs, dataClone, originalDataClone)
        return updatedItem
    },
    globalUpdateObject(object: object, path: string, value: any): any {
        const search = function (path: string, obj: any, value: any) {
            let arr = path.split(/\.(.+)/s)
            // Remove empty strings
            while (arr[arr.length - 1].length == 0) arr.pop()
            let last = arr.pop()
            arr.forEach((element: string) => {
                if (!obj[element] || typeof obj[element] != 'object')
                    obj[element] = {}
                obj = obj[element]
            })
            if (last) {
                if (obj[last] != value) {
                    obj[last] = value
                    return true
                }
            }
            return false
        }
        search(path, object, value)
        return object
    },
}

export default function (app: App) {
    app.mixin({ methods })
}

export const globalUpdateObject = methods.globalUpdateObject
export const prepareDataToSend = methods.prepareDataToSend
